import React, { useState, useEffect, useRef } from 'react';
import './styles.css'; // Import the styles
import { useTranslation } from 'react-i18next';
import IconUp from "../../assets/images/chevron-up.png";
import IconDown from "../../assets/images/chevron-down.png";
const MultiSelect = ({ options, setSelectedRoles, handleCloseSelect, disabled }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const dropdownRef = useRef(null);
  const [prevSelectedOptions, setPrevSelectedOptions] = useState(selectedOptions);

  const { t } = useTranslation();
  const selectedRoles = JSON.parse(localStorage.getItem('roles'));

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOptions((prevSelectedOptions) => {
      if (prevSelectedOptions.includes(option.value)) {
        return prevSelectedOptions.filter((item) => item !== option.value);
      } else {
        return [...prevSelectedOptions, option.value];
      }
    });
    setSelectedRoles((prevSelectedOptions) => {
      if (prevSelectedOptions.includes(option)) {
        return prevSelectedOptions.filter((item) => item !== option);
      } else {
        return [...prevSelectedOptions, option];
      }
    });
  };
  useEffect(() => {
    if (selectedRoles) {
      if (selectedRoles.length > 0) {
        selectedRoles.forEach((element) => {
          const option = options.find((opt) => opt.id === element);
          if (option) {
            setSelectedOptions((prevSelectedOptions) => {
              return [...prevSelectedOptions, option.value];
            });
            setPrevSelectedOptions((prevSelectedOptions) => {
              return [...prevSelectedOptions, option.value];
            });
          }
        });
      }
    }
  }, [disabled]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        const hasDifference =
          selectedOptions.some((option, index) => option !== prevSelectedOptions[index]) ||
          selectedOptions.length !== prevSelectedOptions.length;

        if (selectedOptions.length > 0) {
          if (selectedRoles) {
            if (selectedOptions.length !== selectedRoles.length) {
              if (hasDifference) {
                handleCloseSelect();
                window.location.reload();
              } else {
                setIsOpen(false);
              }
            } else {
              const optionsChanged = selectedOptions.some(
                (option, index) => option !== prevSelectedOptions[index]
              );
              if (optionsChanged) {
                handleCloseSelect();
               window.location.reload();
              } else {
                setIsOpen(false);
              }
            }
          } else {
            if (hasDifference) {
              handleCloseSelect();
              window.location.reload();
            } else {
              setIsOpen(false);
            }
          }
        } else {
          if (hasDifference) {
            handleCloseSelect();
            setIsOpen(false);
            window.location.reload();
          }
        }

        setPrevSelectedOptions(selectedOptions);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selectedOptions, selectedRoles, handleCloseSelect, prevSelectedOptions]);

  /* const renderSelectedText = () => {
    const selectedCount = selectedOptions.length;
    if (selectedCount === 0) {
      return t('noneSelected');
    } else if (selectedCount === options.length) {
      return t('allSelected');
    } else {
      return `${selectedCount} ` + t('selected');
    }
  }; */
  const renderSelectedText = () => {
    const selectedCount = selectedOptions.length;
    if (selectedCount === 0) {
      return t('noneSelected');
    }  else if (selectedCount <= 2) {
      return selectedOptions.join(', ');
    }  else if (selectedCount === options.length) {
      return  t('allSelected');
    } else {
      return `${selectedCount } `+ t('selected');
    }
  };

  const filteredOptions = options.filter((option) =>
    option.value.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="multi-select-header" ref={dropdownRef} title={selectedOptions.join(',')}>
      <div className="dropdown">
        <button
          className="dropdown-button-header"
          style={{
            background: "#eff2f7",
            width: "100%"
          }}
          onClick={toggleDropdown}
        >
          <span
            className="dropdown-text"
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flex: 1,
            }}
          >
            {renderSelectedText()}
          </span>
          {!isOpen ? (
            <img
            src={IconDown}
            alt="Expand"
            style={{  height: '70%' ,marginRight: '4%'}}
          />
          ) : (
            <img
            src={IconUp}
            alt="Collapse"
            style={{ height: '70%' ,marginRight: '4%'}}
          />
          )}
        </button>
        {isOpen && (
          <div
            className="dropdown-menu"
           style={{
              position: "fixed",
              top: dropdownRef.current?.getBoundingClientRect().bottom + "px",
              left: dropdownRef.current?.getBoundingClientRect().left + "px",
              width: dropdownRef.current?.offsetWidth + "px",
              zIndex: 2147483647,
              ...(localStorage.getItem('theme') === 'dark'
                ? { background: '#292929', color: 'white' }
                : {})
            }}
          >
            <div className="search-container">
              <input
                type="text"
                placeholder={t('search')}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
                style={
                  localStorage.getItem('theme') === 'dark'
                    ? { color: 'white' }
                    : {}
                }
              />
            </div>
            {filteredOptions.map((option) => (
              <div
                key={option.id}
                className="dropdown-item"
                style={
                  localStorage.getItem('theme') === 'dark'
                    ? { color: 'white' }
                    : {}
                }
              >
                <label>
                  <input
                    type="checkbox"
                    checked={selectedOptions.includes(option.value)}
                    onClick={() => handleOptionClick(option)}
                  />
                  {option.value}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiSelect;
